module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex/store_images/5_2a11fa3b899a38071db77f8ee460bb47.png";